export default __webpack_public_path__ + "static/media/vertical4.aea06e7d.JPG";